export default {
    props: ['color'],
    template: /*html*/`
        <button class="button" :class="[color]">
            <slot></slot>
        </button>
    `
}